import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { IntercomService } from '../../root/intercom.service';

@Component({
  selector: 'lohi-footer',
  templateUrl: './footer.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent implements OnInit {
  constructor(private intercomService: IntercomService) {}
  @Input()
  public showContactSupport = true;
  @Input()
  public showCannotFindTrailer = true;
  public ngOnInit(): void {}

  public openIntercom() {
    this.intercomService.show();
  }
}
